import type { RewardBundle } from '@vm/shared';

export interface AdPlacement {
  id: string;
  name: string;
  reward: RewardBundle;
  /** Ads of this placement per account per UTC day (on top of the overall AD_DAILY_LIMIT). */
  dailyLimit: number;
}

/**
 * Rewarded-ad placements (never offered to restricted accounts). Ads speed progress up without
 * replacing play: a daily ad watcher earns ~550 gems and ~17 battle pass tiers per season, so the
 * free path to a premium pass stays about one pass per season.
 */
export const AD_REWARDS: AdPlacement[] = [
  { id: 'coins', name: 'Coin boost', reward: { coins: 60 }, dailyLimit: 3 },
  { id: 'gems', name: 'Gem drop', reward: { gems: 3 }, dailyLimit: 2 },
  { id: 'bpxp', name: 'Battle pass boost', reward: { bpXp: 125 }, dailyLimit: 3 },
];

export const AD_REWARD_BY_ID: Record<string, AdPlacement> = Object.fromEntries(AD_REWARDS.map((p) => [p.id, p]));

/** Rewarded ads per account per UTC day (all placements together). */
export const AD_DAILY_LIMIT = 8;
/** Minimum seconds between two rewarded ads. */
export const AD_MIN_INTERVAL_SEC = 20;
